import { UploadCloudIcon } from "@src/app/components/icons/UploadCloud"
import css from "@src/shared/componemts/ImageUploadUI/index.module.css"

type ImageUploadDefaultPlaceholderProps = {
  accept: string
}
export const ImageUploadDefaultPlaceholder = ({
  accept,
}: ImageUploadDefaultPlaceholderProps) => {
  return (
    <div>
      <UploadCloudIcon />

      <p className={css.ImageUploadUI_upload_text}>
        Click or drag file to this area to upload your logo
      </p>

      <span style={{ fontSize: 14 }}>{accept}</span>
    </div>
  )
}
